import React,{useRef} from 'react';
import { Component } from 'react';
import ReactDOM from 'react-dom';

import Header from "../components/header";
import Float from "../components/float";
import Footer from "../components/footer";

import Info from "../components/orders/info";

export default class Orders extends Component {
    constructor(props){
        super(props)

        this.state = {
            name: '',
            orders: [],
            products_cart:[],
            products:[],
            transports:[],
            error: null,
            brands:[],
            brands_2:[],
            categories:[],
            info:[],
        }
    }

    async componentDidMount(){
        //transports
        try{
            let res = await fetch(https+'api/transports')
            let data = await res.json()
            this.setState({
                transports:data,
            })
            console.log("============================")
            console.log(this.state.transports);
        }catch (error) {
            this.setState({
                error
            })
        }
        //orders
        try{
            let res = await fetch(https+'api/orders')
            let data = await res.json()
            this.setState({
                orders:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //products
        try{
            let res = await fetch(https+'api/ordersProducts')
            let data = await res.json()
            this.setState({
                products_cart:data,
            })
            for(var i = 1; i<= cantProductsOrders;i++) {
                this.setState({
                    products:{
                        ...this.state.products,
                        [i]:{
                            id:i,
                            order_id:this.state.products_cart[0][i].order_id,
                            img:this.state.products_cart[0][i].img,
                            name:this.state.products_cart[0][i].name,
                            version:this.state.products_cart[0][i].version,
                            price:this.state.products_cart[0][i].price,
                            cant:this.state.products_cart[0][i].cant
                        }
                    },
                })
            }
            //console.log(data);
            //console.log(cantProductsOrders);
            //console.log(this.state.products);
        }catch (error) {
            this.setState({
                error
            })
        }
        //informacion
        try{
            let res = await fetch(https+'api/info')
            let data = await res.json()
            this.setState({
                info:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //brands
        try{
            let res = await fetch(https+'api/brandsHeader')
            let data = await res.json()
            this.setState({
                brands:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //brands 2
        try{
            let res = await fetch(https+'api/brandsHeader2')
            let data = await res.json()
            this.setState({
                brands_2:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //categories
        try{
            let res = await fetch(https+'api/categoriesHeader')
            let data = await res.json()
            this.setState({
                categories:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }

    }

    render() {
        return (
            <div>
                <Header
                    brands={this.state.brands}
                    brands_2={this.state.brands_2}
                    categories={this.state.categories}
                />
                <Info
                    orders={this.state.orders}
                    products={this.state.products}
                    transports={this.state.transports}
                />
                <Float
                    info={this.state.info}
                />
                <Footer
                    info={this.state.info}
                />
            </div>
        );
    }

}

if (document.getElementById('content_orders')) {
    ReactDOM.render(<Orders />, document.getElementById('content_orders'))
}
